<div
  class="rb-loader-overlay"
  [class.rb-loader-overlay--light]="!commonService.isDarkMode"
  *ngIf="commonService.loaderFlag"
  aria-live="polite"
  aria-busy="true"
>
  <div class="rb-loader" role="status" aria-label="Loading">
    <span
      class="rb-loader-ring"
      [class.rb-loader-ring--light]="!commonService.isDarkMode"
      aria-hidden="true"
    ></span>
    <img
      class="rb-loader-logo"
      src="assets/images/realboard.svg"
      alt=""
      width="56"
      height="56"
    />
  </div>
</div>
